// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sale-area-container[data-v-000314a8] {\n  position: relative;\n  border-bottom: 1px solid #eee;\n  padding-top: 20px;\n}\n.sale-area-container .del-btn[data-v-000314a8] {\n  position: absolute;\n  top: 0;\n  right: -16px;\n  width: 20px;\n  color: red;\n}\n", ""]);
// Exports
module.exports = exports;
